import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import classNames from 'classnames';
import Image from '@client/components/image/Image';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import LinkWrapper from '@client/components/linkWrapper/LinkWrapper';
import styles from './articleCard.scss';

function ArticleCardContent({ className, article, fluidImage }) {
  const imageOrImageUrl = getIn(article, 'image', 'fields', 'file', 'url')
    ? getIn(article, 'image', 'fields', 'file', 'url')
    : getIn(article, 'imageUrl');

  return (
    <div className={classNames(styles.articleCard, className && className)}>
      <div className={fluidImage ? '' : styles.imageContainerCenter}>
        {imageOrImageUrl && (
          <Image
            className={
              !fluidImage ? styles.articleCardImage : styleHelper.imageFluid
            }
            src={imageOrImageUrl}
          />
        )}
      </div>
      <div className={styles.contentContainer}>
        <h3 className={`${styleHelper.titleSmPrimary} ${styles.cardTitle}`}>
          {getIn(article, 'title')}
        </h3>
        <p
          className={`${styleHelper.breadTextPrimary} ${styles.cardDescription}`}
        >
          {getIn(article, 'description')}
        </p>
      </div>
    </div>
  );
}

class ArticleCard extends PureComponent {
  render() {
    const { className, article, fluidImage } = this.props;

    const link = getIn(article, 'slug') ? getIn(article, 'slug') : undefined;

    return (
      <LinkWrapper link={link}>
        <ArticleCardContent
          className={className}
          article={article}
          fluidImage={fluidImage}
        />
      </LinkWrapper>
    );
  }
}

ArticleCard.propTypes = {
  className: PropTypes.string,
  fluidImage: PropTypes.bool,
  article: ImmutablePropTypes.mapContains({
    title: PropTypes.string,
    slug: PropTypes.string,
    description: PropTypes.string,
    imageUrl: PropTypes.string,
  }),
};

export default ArticleCard;
